import { connect, FormikValues } from 'formik'

import { ImageLibraryWithFormik } from '@/components/ImageLibrary'

import { AnyContentBlockTypes } from './NotificationDetail'

type ImageBlockProps = {
  name: string
  readOnly?: boolean
}

const Component = connect(({ name, formik, readOnly = false }: ImageBlockProps & FormikValues) => {
  return <ImageLibraryWithFormik formik={formik} name={`${name}.url`} readOnly={readOnly} />
})

const ImageBlock: AnyContentBlockTypes = { Component }
ImageBlock.displayName = 'Image'
ImageBlock.initialData = {
  type: 'Image',
  id: 'imgBlock',
  url: ''
}

export default ImageBlock
